import { useMutation } from '@tanstack/react-query';

import { apiClient, type EmailAuth, type EmailLoginResponse } from '@api';

/**
 * Starts email login by requesting a magic-link email from the backend.
 *
 * Required params: EmailAuth payload (email, captcha, and venue when required).
 * Important behavior: returns backend response for UI success/error handling.
 *
 * @example
 * const { mutateAsync } = useObtainAuthenticationEmail();
 * await mutateAsync({ email, captcha, venue: venueSlug });
 */
export const useObtainAuthenticationEmail = (options: object = {}) => {
  return useMutation<EmailLoginResponse | undefined, Error, EmailAuth>({
    mutationFn: async (values) => {
      const response = await apiClient.authEmailLoginCreate({
        body: values,
      });
      return response.data;
    },
    ...options,
  });
};
